<div class="default-theme app-shell" data-cy="feature-app-shell">
  <mat-sidenav-container [hasBackdrop]="isSmallScreen()" (backdropClick)="closePreferences()" class="main-container">
    <mat-sidenav
      #sidenav=""
      [mode]="isSmallScreen() ? 'over' : 'side'"
      [opened]="opened()"
      class="navigation-bar h-full w-62.5! pt-2.5"
      data-cy="feature-app-shell-sidenav"
    >
      <div class="box-border flex h-full flex-col justify-between overflow-hidden">
        @if (navigationTree()) {
          <mat-nav-list class="sidenav flex-auto">
            @for (navBlock of navigationTree(); track $index) {
              <iot-platform-ui-sidenav-block data-cy="feature-app-shell-sidenav-block" [navBlock]="navBlock" />
            } @empty {
              ...
            }
          </mat-nav-list>
        }
        <iot-platform-ui-build-info (openReleaseNotes)="openReleaseNotes()" (openChangelog)="openChangelog()" />
      </div>
    </mat-sidenav>

    <mat-sidenav #chatBot="" [opened]="chatBotOpen()" [mode]="isXSmallScreen() ? 'over' : 'side'" position="end" [style.width]="drawerWidth()">
      <iot-platform-ui-chat [chat]="chat()" (dispatchAction)="onDispatchBotAction($event)"></iot-platform-ui-chat>

      <iot-platform-ui-resize-handle
        [parentContainerSelector]="'.main-container'"
        [pageName]="'app-shell'"
        [defaultWidth]="'25rem'"
        [minWidth]="'25rem'"
        [maxWidth]="'50%'"
        [resizable]="true"
        [position]="'end'"
        [resizeElementOpened]="chatBotOpen()"
        [mainSideBarMenuOpened]="opened()"
        (contentWidth)="sideNavContentWidth.set($event)"
        (width)="drawerWidth.set($event)"
      />
    </mat-sidenav>

    <mat-sidenav-content class="main-sidenav-content" [style.width]="isXSmallScreen() ? 'auto' : sideNavContentWidth()">
      <div class="sticky">
        <iot-platform-feature-app-shell-header
          (changeBusinessProfile)="onChangeBusinessProfile($event)"
          (chatBotClicked)="onChatBotClicked()"
          [allowAIChatBot]="allowAiAssistant() && settings.allowChatBot && canReadIOTAssistant()"
          (logoClicked)="returnHome()"
          (logout)="logout()"
          (menuClicked)="toggleSidenav()"
          (myProfile)="openMyProfile()"
          [allowRedirectToMyProfile]="settings.allowRedirectToMyProfile"
          [allowSwitchBusinessProfile]="settings.allowSwitchBusinessProfile"
          [businessProfiles]="businessProfiles()"
          [currentUserLoading]="currentUserLoading() || authPending()"
          [currentUser]="currentUser()"
          [logoIconName]="settings.logoIconName"
          [selectedBusinessProfile]="businessProfile()"
          data-cy="feature-app-shell-header"
        />
      </div>
      <div class="main-sidenav-body">
        @if (contentReady()) {
          <router-outlet></router-outlet>
        } @else {
          <div class="flex h-full w-full items-center justify-center" data-cy="feature-app-shell-content-loader">
            <mat-spinner diameter="48" />
          </div>
        }
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
